<div class="product">
  <div class="image-section">
    <div class="product-image"></div>
  </div>
  <div class="title-section">
    <div class="rating"></div>
    <div class="title"></div>
    <div class="title"></div>
  </div>
  <div class="price-section">
    <div class="prices"></div>
    <div class="bonus"></div>
  </div>
  <div class="buy-section">
    <div class="buy"></div>
  </div>
</div>
